import type { LMScreenFamily } from 'store/units/types';
import LinearMotionScreenSL1D from './LinearMotionScreenSL1D.png';
import LinearMotionScreenSL2D from './LinearMotionScreenSL2D.png';
import LinearMotionScreenSL3D from './LinearMotionScreenSL3D.png';
import LinearMotionScreenSLK1D from './LinearMotionScreenSLK1D.png';
import LinearMotionScreenSLK2D from './LinearMotionScreenSLK2D.png';
import LinearMotionScreenSAK1D from './LinearMotionScreenSAK1D.png';
import LinearMotionScreenSAK2D from './LinearMotionScreenSAK2D.png';
import LinearMotionScreenSL1D2 from './LinearMotionScreenSL1D_2.png';
import LinearMotionScreenSL2D2 from './LinearMotionScreenSL2D_2.png';
import LinearMotionScreenSL3D2 from './LinearMotionScreenSL3D_2.png';
import LinearMotionScreenSLK1D2 from './LinearMotionScreenSLK1D_2.png';
import LinearMotionScreenSLK2D2 from './LinearMotionScreenSLK2D_2.png';
import LinearMotionScreenSAK1D2 from './LinearMotionScreenSAK1D_2.png';
import LinearMotionScreenSAK2D2 from './LinearMotionScreenSAK2D_2.png';

const screenImages = {
  SL: [LinearMotionScreenSL1D, LinearMotionScreenSL2D, LinearMotionScreenSL3D],
  SL_EXCITER: [LinearMotionScreenSLK1D, LinearMotionScreenSLK2D],
  SA_LM: [LinearMotionScreenSAK1D, LinearMotionScreenSAK2D],
} satisfies Record<LMScreenFamily, string[]>;

const screenImages2 = {
  SL: [
    LinearMotionScreenSL1D2,
    LinearMotionScreenSL2D2,
    LinearMotionScreenSL3D2,
  ],
  SL_EXCITER: [LinearMotionScreenSLK1D2, LinearMotionScreenSLK2D2],
  SA_LM: [LinearMotionScreenSAK1D2, LinearMotionScreenSAK2D2],
} satisfies Record<LMScreenFamily, string[]>;

export const getImageLinearMotionScreen = (
  decks: number,
  screenFamily: LMScreenFamily = 'SL',
) => {
  const images = screenImages[screenFamily];
  return images[decks - 1] ?? images[0];
};

export const getImageLinearMotionScreen2 = (
  decks: number,
  screenFamily: LMScreenFamily = 'SL',
) => {
  const images = screenImages2[screenFamily];
  return images[decks - 1] ?? images[0];
};
